<template>
  <div class="afterSale">
    <tooltipLine :visible="!hasBindData.isExistPaypal" :content="t('after-sales::after-sale-list::table_go_bind_tips')">
      <span slot="btn" v-auth="'stores::shop-site::pay-add'">
        <span class="bind-btn" @click="onSetPay">{{ t('after-sales::after-sale-list::table_go_bind') }}</span>
      </span>
    </tooltipLine>
    <el-card class="mb-16">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="t('after-sales::after-sale-list::tab_pending_application')"
          name="pendingApplication"
        ></el-tab-pane>
        <el-tab-pane :label="t('after-sales::after-sale-list::tab_has_application')" name="applicationed">
          <div style="margin-bottom: 24px">
            <span>{{ t('after-sales::after-sale-list::quick_sort') }}</span>
            <el-checkbox-group class="as--order__quickSearch" v-model="selectStatus">
              <el-checkbox :label="2">
                {{ t('after-sales::after-sale-list::pending_refund') }}
              </el-checkbox>
              <el-checkbox :label="1">
                {{ t('after-sales::after-sale-list::rejected') }}
              </el-checkbox>
              <el-checkbox :label="4">
                {{ t('after-sales::after-sale-list::refunded') }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="t('after-sales::after-sale-list::tab_has_close')" name="isClose"></el-tab-pane>
      </el-tabs>
      <z-search
        ref="search"
        v-model="searchForm"
        :configs="searchConfigs"
        :init="handleSearch"
        @do-query="handleSearch"
      ></z-search>
    </el-card>
    <el-card>
      <div class="mb-16">
        <template v-if="activeName === 'pendingApplication'">
          <el-button @click="handleNew" type="primary" v-auth="'after-sales::after-sale-list::add'">
            {{ t('after-sales::after-sale-list::add_after_sales_order') }}
          </el-button>
          <el-button
            :disabled="batchSupplyData.length === 0"
            @click="handleBatchSupply"
            v-auth="'after-sales::after-sale-list::add'"
          >
            {{ t('after-sales::after-sale-list::batch_application') }}
          </el-button>
        </template>
        <el-button
          :disabled="batchRefundData.length === 0"
          @click="handleBatchRefund"
          v-auth="'after-sales::after-sale-list::refund'"
          v-if="activeName === 'applicationed'"
        >
          {{ t('after-sales::after-sale-list::batch_refund') }}
        </el-button>
        <el-button @click="exportList" :loading="exportLoading" v-auth="'after-sales::after-sale-list::export'">
          {{ t('after-sales::after-sale-list::export') }}
        </el-button>
      </div>
      <z-table
        v-loading="loading"
        ref="pendingTable"
        :data="pendingData"
        :columns="pendingColumn"
        :pagination.sync="pagination"
        @selection-change="handleSelectionChange"
        @page-change="getList"
        @cell-mouse-enter="hoverShow"
        @cell-mouse-leave="hideShow"
      >
        <template #refundNo="{ row }">
          <p>{{ row.refundNo }}</p>
          <el-tag>{{ row.refundType }}</el-tag>
        </template>
        <template #payType="{ row }">
          {{ $dataCheck(PAY_TYPE[row.payType]) }}
        </template>
        <template #email="{ row }">
          {{ row.email || '-' }}
        </template>
        <template #good="{ row }">
          <div style="position: relative" @click.stop>
            {{ row.subCounts }}
            <goods-popover :row="row" :activeRow="activeRow"></goods-popover>
          </div>
        </template>
        <template #price="{ row }">${{ $dataCheck(row.amount.toFixed(2)) }}</template>
        <template #afterSaleType="{ row }">
          {{ $t(`system::aftermarket::type::${row.afterSaleType}`, row.afterSaleType) }}
        </template>
        <template #status="{ row }">
          {{ $dataCheck(refundStatus[row.status]) }}
        </template>
        <template #operation="{ row }">
          <el-button type="text" @click.stop="handleDetail(row)" v-auth="'after-sales::after-sale-list::detail'">
            {{ t('after-sales::after-sale-list::table_detail') }}
          </el-button>
          <el-button
            type="text"
            v-if="row.status === 1 || row.status === 0"
            @click.stop="handleEdit(row)"
            v-auth="'after-sales::after-sale-list::edit'"
          >
            {{ t('after-sales::after-sale-list::table_edit') }}
          </el-button>
          <el-button
            type="text"
            v-if="row.applyStatus === 1"
            @click.stop="handleSupply(row)"
            v-auth="'after-sales::after-sale-list::apply'"
          >
            {{ t('after-sales::after-sale-list::table_apply_refund') }}
          </el-button>
          <el-button
            type="text"
            v-if="row.applyStatus === 1"
            @click.stop="handleClose(row)"
            v-auth="'after-sales::after-sale-list::close'"
          >
            <span style="color: red">{{ t('after-sales::after-sale-list::table_close_order') }}</span>
          </el-button>
          <el-button type="text" v-if="row.applyStatus === 2 && row.status === 2" @click.stop="handleBack(row)">
            <span>{{ t('after-sales::after-sale-list::table_reject') }}</span>
          </el-button>
          <el-button type="text" v-if="row.applyStatus === 2 && row.status === 1" @click.stop="handleReset(row)">
            <span>{{ t('after-sales::after-sale-list::table_re_applicate') }}</span>
          </el-button>
          <el-button
            type="text"
            v-if="row.applyStatus === 2 && row.status === 2"
            @click.stop="handleRefund(row)"
            v-auth="'after-sales::after-sale-list::refund'"
          >
            <span>{{ t('after-sales::after-sale-list::table_refund') }}</span>
          </el-button>
        </template>
      </z-table>
    </el-card>
    <!-- 批量退款弹窗 -->
    <batchRefundModal
      ref="batchRefundModal"
      :batchRefundData="batchRefundData"
      :isBatch="isBatch"
      @getList="getList"
      @clearData="clearData"
    ></batchRefundModal>
    <!-- 批量申请弹窗 -->
    <batchSupplyModal
      ref="batchSupplyModal"
      :batchSupplyData="batchSupplyData"
      :isBatch="isBatch"
      @getList="getList"
      @clearData="clearData"
    ></batchSupplyModal>
    <handleDialog v-model="dialogVisible" dialogType="add" @closeDialog="closeDialog"></handleDialog>
  </div>
</template>

<script>
import batchRefundModal from '../components/batchRefund-modal'
import batchSupplyModal from '../components/batchSupply-modal'
import handleDialog from '@/views/store/paySetting/handleDialog'
import { putMerchantConfig } from '@/server/common.js'
import { postOrderList, changeRefundOrderStatus, getRefundOrder, exportExcel } from '@/server/after-sales'
import { downloadBlobFile } from '@/utils'
import GoodsPopover from './goodsPopover.vue'
import moment from 'moment'
import { PAY_TYPE } from '@/config'
import { searchConfigs, pendingColumn, refundStatus } from './config'
export default {
  name: 'afterSale',
  components: {
    batchRefundModal,
    batchSupplyModal,
    handleDialog,
    GoodsPopover
  },
  data() {
    return {
      PAY_TYPE,
      isBatch: false,
      loading: false,
      dialogVisible: false,
      selectStatus: [2, 1, 4],
      activeName: 'pendingApplication',
      activeRow: '',
      searchConfigs,
      searchForm: {
        filterObj: 'refundNo'
      },
      // 待申请表格数据
      pendingData: [],
      // 待申请表格头
      pendingColumn,
      refundStatus,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0
      },
      batchRefundData: [],
      batchSupplyData: [],
      exportLoading: false
    }
  },
  watch: {
    selectStatus() {
      this.getList()
    }
  },
  methods: {
    keepAliveRefresh() {
      this.pagination.pageNum = 1
      this.getList()
    },
    t(key) {
      return this.$t(key)
    },
    onSetPay() {
      this.dialogVisible = true
    },
    async closeDialog(refresh) {
      if (refresh) {
        this.dialogVisible = false
      }
    },
    async exportList() {
      let params = {
        ...this.searchForm,
        apply_status: this.activeName === 'pendingApplication' ? 1 : this.activeName === 'isClose' ? 3 : 2,
        status: this.activeName === 'applicationed' ? this.selectStatus : this.searchForm.status,
        refund_reason_id:
          this.searchForm.refundReasonId && this.searchForm.refundReasonId[this.searchForm.refundReasonId.length - 1]
      }
      delete params.filterObj
      delete params.target
      this.exportLoading = true
      const res = await exportExcel({
        ...params
      })
      this.exportLoading = false
      if (res.code === this.$code) {
        downloadBlobFile(
          res.response.data,
          {
            type: 'application/csv;charset=UTF-8'
          },
          `refundOrders_${moment().format('YYYYMMDD')}.csv`
        )
      }
    },
    handleSearch(params) {
      this.searchForm = params
      this.getList()
    },
    async getBackReason() {
      const { data } = await putMerchantConfig(1)

      if (data.code === this.$code) {
        const fn = obj => {
          if (obj.childrens.length) {
            obj.childrens.map(item => {
              return fn(item)
            })
            return obj
          } else {
            delete obj.childrens
          }
          return obj
        }
        const datas = data.data.map(item => {
          return fn(item)
        })

        this.searchConfigs.map(item => {
          if (item.key === 'refundReasonId') {
            item.componentData.options = datas
            return item
          }
        })
      }
    },
    async getList() {
      this.loading = true
      let params = {
        ...this.pagination,
        ...this.searchForm,
        apply_status: this.activeName === 'pendingApplication' ? 1 : this.activeName === 'isClose' ? 3 : 2,
        status: this.activeName === 'applicationed' ? this.selectStatus : this.searchForm.status,
        refund_reason_id:
          this.searchForm.refundReasonId && this.searchForm.refundReasonId[this.searchForm.refundReasonId.length - 1]
      }
      delete params.filterObj
      delete params.target
      delete params.total
      const { data } = await postOrderList(params)
      if (data.code === 0) {
        this.loading = false
        this.pendingData = data.data.list || []
        this.pagination.total = data.data.total || 0
      }
    },
    handleQuery(value) {
      this.searchForm = {}
      this.getList()
    },
    handleClick(value) {
      this.activeName = value.name
      this.getList()
    },
    handleBatchRefund() {
      this.$refs.batchRefundModal.show()
    },
    handleBatchSupply() {
      this.$refs.batchSupplyModal.show()
    },
    handleSelectionChange(list) {
      this.isBatch = true
      if (this.activeName === 'pendingApplication') {
        this.batchSupplyData = list
      } else if (this.activeName === 'applicationed') {
        this.batchRefundData = list
      }
    },
    handleSupply(row) {
      this.isBatch = false
      this.batchSupplyData = [row]
      this.$refs.batchSupplyModal.show()
    },
    handleRefund(row) {
      this.isBatch = false
      this.batchRefundData = [row]
      this.$refs.batchRefundModal.show()
    },
    handleDetail(row) {
      this.$router.push(`/after-order-detail/${row.id}`)
    },
    handleEdit(row) {
      this.$router.push(`/edit-after-order/${row.id}`)
    },
    handleClose(row) {
      var obj = {
        ids: [row.id],
        apply_status: 3
      }
      changeRefundOrderStatus(obj).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          this.$message.success(this.$t('system::tip::control_success'))
          this.getList()
        } else {
          this.$message.error(this.$t('system::tip::control_error'))
        }
      })
    },
    handleReset(row) {
      this.batchSupplyData = [row]
      this.$refs.batchSupplyModal.show()
    },
    handleBack(row) {
      var obj = {
        ids: [row.id],
        status: 1
      }
      getRefundOrder(obj).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          this.$message.success(this.$t('system::tip::reject_success'))
          this.getList()
        }
      })
    },
    handleNew() {
      this.$router.push('/add-after-order')
    },
    clearData() {
      if (this.activeName === 'pendingApplication') {
        this.batchSupplyData = []
      } else if (this.activeName === 'applicationed') {
        this.batchRefundData = []
      }
    },
    hoverShow(row) {
      this.activeRow = row.refundNo
    },
    hideShow() {
      this.activeRow = ''
    }
  },
  mounted() {
    this.getBackReason()
  }
}
</script>

<style lang="scss" scoped>
.as--order {
  &__quickSearch {
    display: inline-block;
    margin-left: 24px;
    /deep/ .el-checkbox {
      margin-right: 16px;
    }
  }
}
</style>
